import { ReactComponent as LicenceTabIconSvg } from "./icon_tab_licence.svg";
const LicenceTabIcon = (props) => {
  return <LicenceTabIconSvg {...props} />;
};
export default LicenceTabIcon;
